'use strict';

/** Blueground affiliate — Coolliving */
const BLUEGROUND_AFFILIATE_FALLBACK = 'https://www.theblueground.com/?utm_source=coolliving&utm_medium=affiliate&utm_campaign=coliving-search';

const BLUEGROUND_AFFILIATE_SOURCES = new Set(['blueground']);

function isBluegroundAffiliateSource(source) {
  return BLUEGROUND_AFFILIATE_SOURCES.has(String(source || '').toLowerCase());
}

/**
 * Añade parámetros de afiliado a una URL de theblueground.com (ficha o búsqueda).
 * Si no hay URL válida, devuelve el link genérico de afiliado.
 */
function buildBluegroundAffiliateUrl(listingUrl) {
  if (!listingUrl || typeof listingUrl !== 'string') {
    return BLUEGROUND_AFFILIATE_FALLBACK;
  }

  try {
    const parsed = new URL(listingUrl);
    if (!parsed.hostname.toLowerCase().includes('theblueground.com')) {
      return BLUEGROUND_AFFILIATE_FALLBACK;
    }
    parsed.searchParams.set('utm_source', 'coolliving');
    parsed.searchParams.set('utm_medium', 'affiliate');
    parsed.searchParams.set('utm_campaign', 'coliving-search');
    return parsed.toString();
  } catch {
    return BLUEGROUND_AFFILIATE_FALLBACK;
  }
}

/** Promo code shown before redirecting users to Blueground */
const BLUEGROUND_PROMO_CODE = 'AFFILo8S1';

const BLUEGROUND_PROMO_SAVINGS = {
  us: { amount: '$125', label: 'Save up to $125 in New York' },
  uk: { amount: '£85', label: 'Save up to £85 in London' },
  es: { amount: '€85', label: 'Ahorra hasta €85 en España' },
};

/** Textos del modal promo (BluegroundPromoModal.vue) por mercado */
const BLUEGROUND_PROMO_MODAL = {
  us: {
    badge: 'Blueground exclusive offer',
    title: 'Your discount code',
    useCodeText: 'Use this code when booking on Blueground:',
    copyLabel: 'Copy',
    copiedLabel: 'Copied!',
    footerText: "Enter the code at checkout on Blueground to apply your discount. You'll be redirected to the apartment listing in a new tab.",
    ctaLabel: 'Continue to Blueground',
    closeAriaLabel: 'Close',
  },
  uk: {
    badge: 'Blueground exclusive offer',
    title: 'Your discount code',
    useCodeText: 'Use this code when booking on Blueground:',
    copyLabel: 'Copy',
    copiedLabel: 'Copied!',
    footerText: "Enter the code at checkout on Blueground to apply your discount. You'll be redirected to the apartment listing in a new tab.",
    ctaLabel: 'Continue to Blueground',
    closeAriaLabel: 'Close',
  },
  es: {
    badge: 'Oferta exclusiva Blueground',
    title: 'Tu código de descuento',
    useCodeText: 'Usa este código al reservar en Blueground:',
    copyLabel: 'Copiar',
    copiedLabel: '¡Copiado!',
    footerText: 'Introduce el código al finalizar la reserva en Blueground para aplicar tu descuento. Te redirigiremos a la ficha del apartamento en una nueva pestaña.',
    ctaLabel: 'Continuar en Blueground',
    closeAriaLabel: 'Cerrar',
  },
};

function resolveBluegroundPromoRegion(coliving) {
  const region = String(coliving?.region || '').toLowerCase();
  if (region === 'uk') return 'uk';
  if (region === 'us') return 'us';
  if (region === 'es') return 'es';

  const loc = String(coliving?.propertyLocation || coliving?.city || '').toLowerCase();
  if (loc.includes('london')) return 'uk';
  if (loc.includes('madrid') || loc.includes('barcelona')) return 'es';
  return 'us';
}

function getBluegroundPromoCopy(coliving) {
  const region = resolveBluegroundPromoRegion(coliving);
  const savings = BLUEGROUND_PROMO_SAVINGS[region] || BLUEGROUND_PROMO_SAVINGS.us;
  const modal = BLUEGROUND_PROMO_MODAL[region] || BLUEGROUND_PROMO_MODAL.us;

  return {
    code: BLUEGROUND_PROMO_CODE,
    region,
    savingsAmount: savings.amount,
    savingsLabel: savings.label,
    modal,
  };
}

module.exports = {
  BLUEGROUND_AFFILIATE_FALLBACK,
  BLUEGROUND_PROMO_CODE,
  BLUEGROUND_PROMO_SAVINGS,
  BLUEGROUND_PROMO_MODAL,
  isBluegroundAffiliateSource,
  buildBluegroundAffiliateUrl,
  resolveBluegroundPromoRegion,
  getBluegroundPromoCopy,
};
